import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dip } from "interfaces";
import { RootState } from "redux/store";
import { PREFIX } from "./helper";
import { initialState } from "./initial-state";

export const bundleUpSlice = createSlice({
	name: PREFIX,
	initialState,
	reducers: {
		onSetTimers: (
			state,
			action: PayloadAction<{
				endTime?: string;
				cooldownTime?: string;
			}>
		) => {
			if ("endTime" in action.payload) {
				state.endTime = action.payload.endTime;
			}
			if ("cooldownTime" in action.payload) {
				state.cooldownTime = action.payload.cooldownTime;
			}
		},
		onSetBundleUpDip: (state, action: PayloadAction<Dip | undefined>) => {
			state.dip = action.payload;
		}
	}
});

export const { onSetTimers, onSetBundleUpDip } = bundleUpSlice.actions;

export const selectBundleUpState = (state: RootState) => state.bundleUp;
export default bundleUpSlice.reducer;
export * from "./types";
